<template>
  <div style="width: 100%;">
  <NewNavBar></NewNavBar>
  <router-view></router-view>
  </div>
</template>
<script >
import NewNavBar from "@/layouts/NewNavBar.vue";

export default {
  name: "layoutIndex",
  components: {NewNavBar},
  methods:{

  }
}
</script>
<style >

</style>



// WEBPACK FOOTER //
// src/layouts/NewIndex.vue